import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55a66de9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-title" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "box-details" }
const _hoisted_5 = { class: "detail-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label fw-bold" }, "Request Sent: ", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = {
  key: 0,
  class: "box-details"
}
const _hoisted_9 = { class: "detail-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label fw-bold" }, "Reminder Sent: ", -1))
const _hoisted_11 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'box': true,
      'cursor-pointer': _ctx.data.state === 'UPDATED',
    }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToReviewSentRequest()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.index) + ": Partner Name:", 1),
        _createTextVNode(" " + _toDisplayString(_ctx.data.name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatDate(_ctx.data.created_at)), 1)
      ])
    ]),
    (_ctx.data.reminder_at)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.data.reminder_at ? _ctx.formatDate(_ctx.data.reminder_at) : '-'), 1)
          ]),
          _createElementVNode("span", {
            class: _normalizeClass({
        'status': true,
        'is-completed-color': _ctx.data.state === 'COMPLETED'
        })
          }, "Status: " + _toDisplayString(_ctx.data.state), 3)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}